import { UserRecord } from './user.types';

export const userRecordsMock: UserRecord[] = [
    {
        id: '401',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'ppolasek@srsacquiom.com',
        nsContactName: 'Phil Polasek',
        firstName: 'Phil',
        middleName: null,
        lastName: 'Polasek',
        status: 'Active',
        phoneNr: '+13035552842',
        auth0Id: 'auth0|121212000401',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
            {
                id: 3,
                name: 'Clearinghouse',
                abbr: 'CH',
            },
        ],
    },
    {
        id: '402',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Maximo.Schumm@acme.com',
        nsContactName: 'Maximo Schum',
        firstName: 'Maximo',
        middleName: null,
        lastName: 'Schumm',
        status: 'Active',
        phoneNr: '+13035551604',
        auth0Id: 'auth0|121212000402',
    },
    {
        id: '403',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Garnett.Thompson@acme.com',
        nsContactName: 'Garnett Thompson',
        firstName: 'Garnett',
        middleName: null,
        lastName: 'Thompson',
        status: 'Active',
        phoneNr: '+13035553794',
        auth0Id: 'auth0|121212000403',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
            {
                id: 3,
                name: 'Clearinghouse',
                abbr: 'CH',
            },
        ],
    },
    {
        id: '404',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Tate.Wyman@acme.com',
        nsContactName: 'Tate Wyman',
        firstName: 'Tate',
        middleName: null,
        lastName: 'Wyman',
        status: 'Active',
        phoneNr: '+13035552064',
        auth0Id: 'auth0|121212000404',
    },
    {
        id: '405',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Alva.Hoppe@acme.com',
        nsContactName: 'Alva Hoppe',
        firstName: 'Alva',
        middleName: null,
        lastName: 'Hoppe',
        status: 'Active',
        phoneNr: '+13035555211',
        auth0Id: 'auth0|121212000405',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
        ],
    },
    {
        id: '406',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Andre.Maggio@acme.com',
        nsContactName: 'Andre Maggio',
        firstName: 'Andre',
        middleName: null,
        lastName: 'Maggio',
        status: 'Active',
        phoneNr: '+13035554139',
        auth0Id: 'auth0|121212000406',
    },
    {
        id: '407',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Humberto.Koss@acme.com',
        nsContactName: 'Humberto Koss',
        firstName: 'Humberto',
        middleName: null,
        lastName: 'Koss',
        status: 'Active',
        phoneNr: '+13035557541',
        auth0Id: 'auth0|121212000407',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '408',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Hallie.Kovacek@acme.com',
        nsContactName: 'Hallie Kovacek',
        firstName: 'Hallie',
        middleName: null,
        lastName: 'Kovacek',
        status: 'Active',
        phoneNr: '+13035551655',
        auth0Id: 'auth0|121212000408',
    },
    {
        id: '409',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Wilmer.Keeling@acme.com',
        nsContactName: 'Wilmer Keeling',
        firstName: 'Wilmer',
        middleName: null,
        lastName: 'Keeling',
        status: 'Active',
        phoneNr: '+13035556905',
        auth0Id: 'auth0|121212000409',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '410',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Nicholas.Reichel@acme.com',
        nsContactName: 'Nicholas Reichel',
        firstName: 'Nicholas',
        middleName: null,
        lastName: 'Reichel',
        status: 'Active',
        phoneNr: '+13035554865',
        auth0Id: 'auth0|121212000410',
    },
    {
        id: '19',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Kim.Gusikowski@acme.com',
        nsContactName: 'Kim Gusikowski',
        firstName: 'Kim',
        middleName: null,
        lastName: 'Gusikowski',
        status: 'Active',
        phoneNr: '+13035558547',
        auth0Id: 'auth0|121212000019',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
        ],
    },
    {
        id: '20',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Nelson.King@acme.com',
        nsContactName: 'Nelson King',
        firstName: 'Nelson',
        middleName: null,
        lastName: 'King',
        status: 'Active',
        phoneNr: '+13035556790',
        auth0Id: 'auth0|121212000020',
    },
    {
        id: '21',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Odessa.Auer@acme.com',
        nsContactName: 'Odessa Auer',
        firstName: 'Odessa',
        middleName: null,
        lastName: 'Auer',
        status: 'Active',
        phoneNr: '+13035556652',
        auth0Id: 'auth0|121212000021',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '22',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Raven.Hilll@acme.com',
        nsContactName: 'Raven Hilll',
        firstName: 'Raven',
        middleName: null,
        lastName: 'Hilll',
        status: 'Active',
        phoneNr: '+13035554729',
        auth0Id: 'auth0|121212000022',
    },
    {
        id: '23',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Julie.Yost@acme.com',
        nsContactName: 'Julie Yost',
        firstName: 'Julie',
        middleName: null,
        lastName: 'Yost',
        status: 'Active',
        phoneNr: '+13035554523',
        auth0Id: 'auth0|121212000023',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '24',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Deshaun.Rosenbaum@acme.com',
        nsContactName: 'Deshaun Rosenbaum',
        firstName: 'Deshaun',
        middleName: null,
        lastName: 'Rosenbaum',
        status: 'Active',
        phoneNr: '+13035554916',
        auth0Id: 'auth0|121212000024',
    },
    {
        id: '25',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Tommie.Roberts@acme.com',
        nsContactName: 'Tommie Roberts',
        firstName: 'Tommie',
        middleName: null,
        lastName: 'Roberts',
        status: 'Active',
        phoneNr: '+13035557967',
        auth0Id: 'auth0|121212000025',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
        ],
    },
    {
        id: '26',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Shania.Mills@acme.com',
        nsContactName: 'Shania Mills',
        firstName: 'Shania',
        middleName: null,
        lastName: 'Mills',
        status: 'Active',
        phoneNr: '+13035559109',
        auth0Id: 'auth0|121212000026',
    },
    {
        id: '27',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Kenton.Schneider@acme.com',
        nsContactName: 'Kenton Schneider',
        firstName: 'Kenton',
        middleName: null,
        lastName: 'Schneider',
        status: 'Active',
        phoneNr: '+13035554830',
        auth0Id: 'auth0|121212000027',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '28',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Gerda.Metz@acme.com',
        nsContactName: 'Gerda Metz',
        firstName: 'Gerda',
        middleName: null,
        lastName: 'Metz',
        status: 'Active',
        phoneNr: '+13035558378',
        auth0Id: 'auth0|121212000028',
    },
    {
        id: '29',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Armando.Hauck@acme.com',
        nsContactName: 'Armando Hauck',
        firstName: 'Armando',
        middleName: null,
        lastName: 'Hauck',
        status: 'Active',
        phoneNr: '+13035553244',
        auth0Id: 'auth0|121212000029',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
        ],
    },
    {
        id: '30',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Florida.Corwin@acme.com',
        nsContactName: 'Florida Corwin',
        firstName: 'Florida',
        middleName: null,
        lastName: 'Corwin',
        status: 'Active',
        phoneNr: '+13035550218',
        auth0Id: 'auth0|121212000030',
    },
    {
        id: '31',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Bell.Stiedemann@acme.com',
        nsContactName: 'Bell Stiedemann',
        firstName: 'Bell',
        middleName: null,
        lastName: 'Stiedemann',
        status: 'Active',
        phoneNr: '+13035552555',
        auth0Id: 'auth0|121212000031',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '32',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Charlie.Kuhn@acme.com',
        nsContactName: 'Charlie Kuhn',
        firstName: 'Charlie',
        middleName: null,
        lastName: 'Kuhn',
        status: 'Active',
        phoneNr: '+13035557567',
        auth0Id: 'auth0|121212000032',
    },
    {
        id: '33',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Terrance.Johnson@acme.com',
        nsContactName: 'Terrance Johnson',
        firstName: 'Terrance',
        middleName: null,
        lastName: 'Johnson',
        status: 'Active',
        phoneNr: '+13035551466',
        auth0Id: 'auth0|121212000033',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
            {
                id: 3,
                name: 'Clearinghouse',
                abbr: 'CH',
            },
        ],
    },
    {
        id: '34',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Reginald.Hudson@acme.com',
        nsContactName: 'Reginald Hudson',
        firstName: 'Reginald',

        middleName: null,        lastName: 'Hudson',
        status: 'Active',
        phoneNr: '+13035552519',
        auth0Id: 'auth0|121212000034',
    },
    {
        id: '35',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Enos.Bergstrom@acme.com',
        nsContactName: 'Enos Bergstrom',
        firstName: 'Enos',
        middleName: null,
        lastName: 'Bergstrom',
        status: 'Active',
        phoneNr: '+13035555472',
        auth0Id: 'auth0|121212000035',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
            {
                id: 2,
                name: 'Shareholder Portal',
                abbr: 'SHARP',
            },
        ],
    },
    {
        id: '36',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Reid.Carroll@acme.com',
        nsContactName: 'Reid Carroll',
        firstName: 'Reid',
        middleName: null,
        lastName: 'Carroll',
        status: 'Active',
        phoneNr: '+13035551846',
        auth0Id: 'auth0|121212000036',
    },
    {
        id: '37',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Ignatius.Mohr@acme.com',
        nsContactName: 'Ignatius Mohr',
        firstName: 'Ignatius',
        middleName: null,
        lastName: 'Mohr',
        status: 'Active',
        phoneNr: '+13035556953',
        auth0Id: 'auth0|121212000037',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
    {
        id: '38',
        nsId: 0,
        nsLastModified: 1693191489125,
        email: 'Haley.Tillman@acme.com',
        nsContactName: 'Haley Tillman',
        firstName: 'Haley',
        middleName: null,
        lastName: 'Tillman',
        status: 'Active',
        phoneNr: '+13035553177',
        auth0Id: 'auth0|121212000038',
        applications: [
            {
                id: 1,
                name: 'Deal Dashboard',
                abbr: 'DD',
            },
        ],
    },
];
